// Switching the map a client plays at runtime (an offline match on an editor map). active.ts stays the map
// baked into the build — what the server runs; this module holds the one currently played and rebinds
// layout.ts's LAYOUT and terrain functions to it. Every importer sees the switch through ES live bindings;
// anything built from them earlier (a NavGrid, a map view, a Game) must be built again. The server never
// calls setActiveMap().
import { ACTIVE_MAP, MAP_HASH } from './active.js';
import { hashMap } from './hash.js';
import { bindLayout } from '../layout.js';
import type { MapData } from './schema.js';

export let CURRENT_MAP_HASH: string = MAP_HASH;

/** `map` must already be validated (validateMap). A no-op when it is the map already played. */
export function setActiveMap(map: MapData) {
  const hash = hashMap(map);
  if (hash === CURRENT_MAP_HASH) return;
  CURRENT_MAP_HASH = hash;
  bindLayout(map);
}

/** Back to the baked map — the server's, so always before going online. */
export function resetActiveMap() {
  setActiveMap(ACTIVE_MAP);
}
